
<template>
  <div class="bgfff out_wrap">
    <div class="back_wrap">
      <el-button @click="$router.go(-1)"><i class="el-icon-arrow-left" />返回</el-button>
      <span class="fs16 bold ml20">普通充值</span>
    </div>
    <!-- <el-divider></el-divider> -->
    <div class="pdlr20">
      <div class="collection_title bold">平台方收款信息</div>
      <div class="mt20 mb20">
        <el-form ref="rechangeModal" :model="form" label-suffix=":" class="plr100" label-width="90px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="收款公司"><span class=" inline" style="line-height:normal;">{{ bankInfo.company_name }}</span></el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户行"><span class=" inline" style="line-height:normal;padding-top: 7px;">{{ bankInfo.bank_name }}</span></el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="收款账号"><span class=" inline" style="line-height:normal;">{{ bankInfo.bank_card }}</span></el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="收款方式">公对公转账</el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="collection_title bold mb20">充值信息</div>
        <el-form ref="rechangeModal" :model="form" label-suffix=":" label-width="115px">
          <div class="plr100">
            <el-row>
              <el-col :span="12">
                <el-form-item
                  label="充值金额"
                  prop="recharge_price"
                  :rules="[{
                    required: true, message: '充值金额不能为空', trigger: 'blur'
                  }, {validator: validatorFn, trigger: 'blur'}]"
                >
                  <el-input v-model="form.recharge_price" class="w150" @input="changeFn" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="服务费率">{{ rechangeDetail.rate }}%</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="预扣服务费">￥{{ serviceCost || '0.00' }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="上传凭证"
                  prop="pic"
                  :rules="{
                    required: true, message: '请上传凭证', trigger: 'blur'
                  }"
                >
                  <el-upload
                    action="#"
                    :auto-upload="true"
                    :before-upload="beforeUploadFile"
                    :http-request="doUploadFile"
                    :multiple="false"
                    :limit="1"
                    :on-exceed="handleExceed"
                    :on-remove="handleRemove"
                    :file-list="fileList"
                  >
                    <el-button size="small" type="primary">点击上传</el-button>
                    <span class="ml5 fs12">可以上传doc/docx/pdf/jpg/png/xls/xlsx文件,且不超过20M</span>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="collection_title bold mb20">商户号可分配金额：￥{{ clientReal || '0.00' }}</div>
          <div class="flex_column">
            <div v-for="(mch_list, index) in form.mch_list" :key="mch_list.mch_id" class="mch-item mr30 mt10">
              <el-form-item :label="`${mch_list.type == 1 ? '微信' : '支付宝'}商户号${index + 1}`">
                {{ mch_list.mch_id }}
              </el-form-item>
              <el-form-item label="可用余额">￥{{ mch_list.use_price || '0.00' }}</el-form-item>
              <el-form-item
                label="分配金额"
                :prop="'mch_list.' + index + '.price'"
                :rules="{
                  required: true, message: '分配金额不能为空', trigger: 'blur'
                }"
              >
                <el-input v-model="mch_list.price" class="w200" @input="(val) => changeValue(val, index)" />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="center">
      <el-button type="primary" @click="submitFn('rechangeModal')">确 认 充 值</el-button>
    </div>
  </div>
</template>

<script>

// api接口
import { rechargeInfo, rechargeAdd } from '@/api/refund'
import { uploadFile } from '@/api/common'
import { getBankInfo } from '@/api/refund'
export default {
  data() {
    return {
      dialogVisible: false,
      fileList: [],
      bankInfo: {},
      form: {
        recharge_price: '', // 充值金额
        pic: '', // 上传凭证
        mch_list: [] // 分配商户号金额
      },
      rechangeDetail: {} // 充值详情
    }
  },
  computed: {
    // 商户号充值可分配金额
    clientReal() {
      // 总的充值金额 - 服务费
      return this.toDecimal(this.div(this.form.recharge_price, this.add(1, (this.div(this.rechangeDetail.rate, 100)))))
    },
    // 服务费
    serviceCost() {
      // 总的充值金额 * 服务费率
      return this.toDecimal(this.sub(this.form.recharge_price, this.clientReal) || 0.00)
    }
  },
  watch: {
    rechangeDetail: {
      handler(val) {
        if (val && val.mch_list && val.mch_list.length) {
          val.mch_list.forEach(item => {
            this.form.mch_list.push({
              mch_id: item.mch_id,
              use_price: (item.use_price / 100).toFixed(2),
              type: item.type,
              price: 0
            })
          })
        }
      },
      deep: true
    }
  },
  created() {
    this.rechargeFn()
  },
  mounted() {
    getBankInfo().then(res => {
      this.bankInfo = res.data
    })
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    // 充值
    async rechargeFn() {
      // 获取充值详情
      const res = await rechargeInfo()
      if (res.code === 200) {
        this.rechangeDetail = res.data
      }
    },
    async submitFn(formName) {
      const valid = await this.$refs[formName].validate()
      if (!valid) return
      var sum = 0
      this.form.mch_list.forEach(item => {
        sum = this.add(sum, item.price)
      })
      if (+this.clientReal !== sum) {
        this.$message({ type: 'error', message: '商户号充值金额与商户号充值可分配金额不相等!' })
        return
      }
      if (valid) {
        const res = await rechargeAdd(this.form)
        if (res.code === 200) {
          this.$message({ type: 'success', message: '充值申请提交成功!' })
          this.$router.go(-1)
          this.fileList = []
          this.form.recharge_price = '' // 充值金额
          this.form.pic = '' // 上传凭证
          this.form.mch_list = [] // 分配商户号金额
        // this.query()
        }
      }
    },
    changeValue(val, i) {
      this.form.mch_list[i].price = val.replace(/[^\d\.]/g, '').replace(/^\./g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
    },
    changeFn(val) {
      this.form.recharge_price = val.replace(/[^\d\.]/g, '').replace(/^\./g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
    },
    beforeUploadFile(file) {
      const type = /^(.doc|.docx|.pdf|.jpg|.png|.xls|.xlsx)$/.test(file.name.slice(file.name.lastIndexOf('.')))
      const size = file.size / 1024 / 1024 < 20
      if (!type) {
        this.$message('不支持该文件类型,请重新选择')
      }
      if (!size) {
        this.$message('文件大小不可超过20MB')
      }
      return type && size
    },
    doUploadFile(file) {
      console.log(file, 'file')
      const params = new FormData()
      params.append('file', file.file)
      uploadFile(params).then(res => {
        if (res.code === 200) {
          this.form.pic = res.data
        }
      })
    },
    handleExceed() {
      this.$message('最多可上传1个文件')
    },
    handleRemove() {
      this.form.pic = ''
    },
    validatorFn(rule, value, callback) {
      if (+value <= 0) {
        callback(new Error(`金额必须大于0`))
      } else {
        callback()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.back{
    width: 69px;
    height: 26px;
    line-height: 26px;
    text-align: center;
    border: 1px solid #1890FF;
    color: #1890FF;
    font-size: 14px;
}
.flex_start{
    display: flex;
    align-items: center;
    justify-content: flex-start;
}
.collection_title{
 width: 100%;
 height: 42px;
 line-height: 42px;
 background: #FAFAFA;
 padding-left: 22px;
 border-left: 4px solid #1890FF;
 font-size: 15px;
}
.plr100{
    padding: 0px 100px;
}
.line{
    width: 1px;
    height: 100%;
    background: #D8D8D8;
}
.mch-item{
  padding:  10px;
  margin-bottom: 10px;
  border: 1px solid #EDEDED;
  width: 340px;
//   &:last-child{
//     margin-bottom: 0;
//   }
}
.flex_column{
     flex-flow: row wrap;
    justify-content: flex-start;
    display: flex;
    padding: 0px 30px;
}
.pdlr20{
    padding: 0px 20px;
}
.mr30{
  margin-right: 30px;
}
.posifix{
   position: fixed;
    left: 0;
    bottom: 50px;
  // padding-left: 200px;
  // padding-right: 20px;
  width: 100%;
  transform: translateZ(0)
}
.el-form-item { margin-bottom: 10px;}
</style>
